/* onpace-pdp-v2.js -- PDP v2 (9 Oct 2026). Behaviour for the components the PDP borrows from the collection page:
   the Kinomap console (route picker, live HUD from Kinomap's own route data, footage mapped onto the model's
   display), the overview video card, the quality checklist ticks and the testing film. One shared video player.
   Lifted from the collection build (rounds 1, 15, 17, 22); included by two sections, so it guards itself. */
(function () {
  if (window.__opxPdp) return; window.__opxPdp = true;
  var still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function onView(el, fn, th, margin) {
    if (!el) return;
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); },
      { threshold: th || 0.35, rootMargin: margin || '0px' });
    io.observe(el);
  }
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  // ---- the shared player (built on first use) ----
  var dlg = null, dv = null;
  function player() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog'); dlg.className = 'po3v'; dlg.setAttribute('aria-label', 'Video');
    dlg.innerHTML = '<button type="button" class="po3v__x" aria-label="Close">&times;</button><video playsinline controls preload="none"></video>';
    var wrap = document.createElement('div'); wrap.className = 'opx'; wrap.appendChild(dlg); document.body.appendChild(wrap);
    dv = dlg.querySelector('video');
    function shut() { dv.pause(); dlg.close(); }
    dlg.querySelector('.po3v__x').addEventListener('click', shut);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
    dlg.addEventListener('close', function () { dv.pause(); dlg.classList.remove('is-wide'); });
    return dlg;
  }
  function open(src, wide) { player(); dlg.classList.toggle('is-wide', !!wide); dv.src = src; dlg.showModal(); dv.currentTime = 0; play(dv); }

  // ---- Kinomap console ----
  var km = document.querySelector('[data-km]');
  if (km) {
    var vid = km.querySelector('#kmVid'), scr = km.querySelector('#kmScreen'), place = km.querySelector('#kmPlace'),
        routes = km.querySelectorAll('.km2__route'), hw = km.querySelector('.km2__hw'), D = null, live = false, pend = null;
    var ui = scr.querySelector('.ohk'), H = {};
    ['k-dur', 'ohk-sec', 'k-spd', 'k-dst', 'k-gain', 'k-inc', 'k-slope'].forEach(function (c) { H[c] = ui.querySelector('.' + c); });
    var bars = [].slice.call(ui.querySelectorAll('.k-bars i'));
    function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
    function pad2(x) { return (x < 10 ? '0' : '') + x; }
    function col(g) { return g < -1 ? '#3B8BF5' : g < 1.5 ? '#38B64C' : g < 4 ? '#F2C230' : g < 8 ? '#F08B2C' : '#E2483A'; }
    function hud() {
      if (!D) return; var d = D.d, t = D.t0 + (vid.currentTime || 0), k = 0, g = D.g0 || 0, i;
      while (k < d.length - 2 && d[k + 1][0] <= t) k++;
      for (i = 1; i <= k; i++) g += Math.max(0, d[i][2] - d[i - 1][2]);
      var a = d[k], b = d[Math.min(k + 1, d.length - 1)], f = b[0] > a[0] ? clamp((t - a[0]) / (b[0] - a[0]), 0, 1) : 0;
      var dist = a[1] + (b[1] - a[1]) * f, kmh = a[3] + (b[3] - a[3]) * f, slope = a[4] + (b[4] - a[4]) * f, mx = D.max || 15, inc = clamp(slope, 0, mx), el = Math.floor(t);
      H['k-dur'].textContent = Math.floor(el / 60); H['ohk-sec'].textContent = ':' + pad2(el % 60); H['k-spd'].textContent = kmh.toFixed(1);
      var du = H['k-dst'].parentNode.querySelector('.ohk-u');
      if (dist >= 1000) { H['k-dst'].textContent = (dist / 1000).toFixed(2); du.textContent = 'km'; } else { H['k-dst'].textContent = Math.round(dist); du.textContent = 'm'; }
      H['k-gain'].textContent = Math.round(g); H['k-inc'].textContent = Math.round(inc);
      var lit = Math.round(inc / mx * bars.length); bars.forEach(function (x, j) { x.className = bars.length - j <= lit ? 'on' : ''; });
      H['k-slope'].textContent = (slope > 0 ? '+' : '') + slope.toFixed(1) + '%'; H['k-slope'].style.background = col(slope);
    }
    vid.addEventListener('timeupdate', hud);
    function srcOf(r) { return (innerWidth < 750 && r.dataset.srcM) ? r.dataset.srcM : r.dataset.src; }
    function pick(r, go) {
      routes.forEach(function (x) { x.classList.toggle('is-on', x === r); x.setAttribute('aria-pressed', String(x === r)); });
      D = JSON.parse(r.dataset.hud); place.textContent = r.dataset.place;
      var img = r.querySelector('img'); if (img) vid.poster = img.currentSrc || img.src;
      if (live) vid.src = srcOf(r); else pend = srcOf(r);
      hud(); if (go && live) play(vid);
    }
    routes.forEach(function (r) { r.addEventListener('click', function () { live = true; pick(r, true); }); });
    // the footage sits on the model's own display: a 1280x720 layer mapped onto its four measured corners
    var QUAD = JSON.parse(scr.dataset.quad || '[[0,0],[1800,0],[1800,1012],[0,1012]]'), QW = 1800;
    function homog(w, h, q) {
      var src = [[0, 0], [w, 0], [w, h], [0, h]], A = [], B = [];
      for (var i = 0; i < 4; i++) { var x = src[i][0], y = src[i][1], u = q[i][0], v = q[i][1];
        A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); B.push(u); A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); B.push(v); }
      for (var c = 0; c < 8; c++) { var pv = c; for (var r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[pv][c])) pv = r;
        var t = A[c]; A[c] = A[pv]; A[pv] = t; t = B[c]; B[c] = B[pv]; B[pv] = t;
        for (var r2 = 0; r2 < 8; r2++) { if (r2 === c) continue; var f = A[r2][c] / A[c][c]; for (var k = c; k < 8; k++) A[r2][k] -= f * A[c][k]; B[r2] -= f * B[c]; } }
      var h8 = B.map(function (b, i) { return b / A[i][i]; });
      return [h8[0], h8[3], 0, h8[6], h8[1], h8[4], 0, h8[7], 0, 0, 1, 0, h8[2], h8[5], 0, 1];
    }
    function fit() { if (!hw.clientWidth) return; var k = hw.clientWidth / QW;
      scr.style.transform = 'matrix3d(' + homog(1280, 720, QUAD.map(function (p) { return [p[0] * k, p[1] * k]; })).join(',') + ')'; }
    if (hw.complete) fit(); hw.addEventListener('load', fit); addEventListener('resize', fit);
    if (window.ResizeObserver) new ResizeObserver(fit).observe(hw);
    pick(km.querySelector('.km2__route.is-on') || routes[0], false);
    // footage only loads near the section, and only plays while it's on screen
    onView(km, function () { live = true; if (pend) { vid.src = pend; pend = null; } }, 0, '600px 0px');
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (en) {
      if (en.isIntersecting) { live = true; if (pend) { vid.src = pend; pend = null; } if (!still) play(vid); } else vid.pause(); }); }, { threshold: 0.2 }).observe(scr);
    // the bonus card: its thumbnail plays (muted) once near, and opens the overview video
    var tour = km.querySelector('.km2__tour');
    if (tour) {
      var tv = tour.querySelector('video');
      onView(tour, function () { tv.src = tv.getAttribute('data-src'); if (!still) play(tv); }, 0.2);
      tour.addEventListener('click', function () { open(tour.getAttribute('data-video'), false); });
    }
    // How it works (Tris 10 Oct): opening the accordion moves only the card below it, never the console. The two
    // columns are centred against each other as they stand with the accordion CLOSED, then pinned to the top.
    var how = km.querySelector('.km2__how'), grid = km.querySelector('.km2__grid'),
        copy = km.querySelector('.km2__copy'), player = km.querySelector('.km2__player');
    if (how && grid && copy && player) {
      var pin = function () {
        copy.style.marginTop = player.style.marginTop = '';
        if (getComputedStyle(grid).gridTemplateColumns.split(' ').length < 2) { grid.style.alignItems = ''; return; }
        var steps = how.querySelector('.km2__steps'),
            extra = how.open && steps ? steps.offsetHeight + parseFloat(getComputedStyle(steps).marginBottom || 0) : 0,
            d = (copy.offsetHeight - extra) - player.offsetHeight;
        grid.style.alignItems = 'start';
        (d > 0 ? player : copy).style.marginTop = Math.abs(d) / 2 + 'px';
      };
      pin(); addEventListener('resize', pin); how.addEventListener('toggle', pin);
      if (window.ResizeObserver) new ResizeObserver(pin).observe(player);
    }
  }

  // ---- the buy button says what's paid today, and follows STOQ's choice: deposit, or in full (Afterpay / Zip).
  //      STOQ rewrites the button's text on load, so ours is put back whenever it does. ----
  var opBtn = document.querySelector('[data-op-label]');
  if (opBtn) {
    var depLbl = opBtn.getAttribute('data-op-label'), fullLbl = opBtn.getAttribute('data-op-label-full') || depLbl,
        fullPlan = opBtn.getAttribute('data-op-full-plan'), bar = document.querySelector('[data-op-bar-cta]'),
        barDep = bar ? bar.innerHTML : '', mo;
    var isFull = function () {
      var r = document.querySelector('input[name="preorder-option"]:checked');
      return !!(r && fullPlan && r.value === String(fullPlan));
    };
    var fix = function () {
      var want = isFull() ? fullLbl : depLbl, m = opBtn.querySelector('.op-cta__main'), s = opBtn.querySelector('.op-cta__sub');
      var probe = document.createElement('div'); probe.innerHTML = want;
      if (!(m && s && m.textContent === 'Pre-order now' && s.textContent === probe.querySelector('.op-cta__sub').textContent)) {
        mo.disconnect(); opBtn.innerHTML = want; mo.observe(opBtn, { childList: true, characterData: true, subtree: true });
      }
      if (bar) { var b = isFull() ? 'Pre-order now' : barDep; if (bar.innerHTML !== b) bar.innerHTML = b; }
    };
    mo = new MutationObserver(fix);
    mo.observe(opBtn, { childList: true, characterData: true, subtree: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'preorder-option') fix(); });
    fix(); setTimeout(fix, 1500); setTimeout(fix, 4000);
  }

  // ---- STOQ's two options, in ON:PACE's style (round 9): the amount after the "|" moves to the right of the row,
  //      and the Afterpay / Zip block moves into the pay-in-full row -- the only option it applies to.
  //      STOQ renders (and can re-render) the widget itself, so this is re-applied whenever it does. ----
  var buyForm = document.getElementById('op-form');
  if (buyForm) {
    var fullId = (document.querySelector('[data-op-full-plan]') || { getAttribute: function () { return ''; } }).getAttribute('data-op-full-plan');
    var stoq = function () {
      var w = buyForm.querySelector('.restock-rocket-payment-widget'); if (!w) return;
      if (!w.classList.contains('opx-po')) w.classList.add('opx-po');
      [].forEach.call(w.querySelectorAll('.restock-rocket-payment-title'), function (l) {
        if (l.querySelector('.opx-po__amt')) return;
        var s = l.textContent, i = s.lastIndexOf('|'); if (i < 0) return;
        var a = document.createElement('span'), b = document.createElement('span');
        a.className = 'opx-po__t'; a.textContent = s.slice(0, i).trim();
        b.className = 'opx-po__amt'; b.textContent = s.slice(i + 1).trim();
        l.textContent = ''; l.appendChild(a); l.appendChild(b);
      });
      var full = fullId && w.querySelector('[data-selling-plan-id="' + fullId + '"] .restock-rocket-payment-description');
      // a COPY goes in: STOQ re-renders its own markup and would take a moved original with it
      var bn = document.querySelector('.op-buy > .op-bnpl');
      if (full && bn && !full.querySelector('.opx-po__bnpl')) {
        var c = bn.cloneNode(true); c.classList.add('opx-po__bnpl'); full.appendChild(c);
        if (!bn.classList.contains('opx-bnpl-src')) bn.classList.add('opx-bnpl-src');
      }
    };
    new MutationObserver(stoq).observe(buyForm, { childList: true, subtree: true });
    stoq();
  }

  // ---- pre-order cards: Kinomap and the program play their previews in the shared player ----
  [].forEach.call(document.querySelectorAll('.opx .po3__vid'), function (b) {
    b.addEventListener('click', function () { open(b.getAttribute('data-video'), false); });
  });

  // ---- quality: the hand-check ticks land one by one; the testing film opens wide ----
  var q = document.querySelector('[data-qc]');
  if (q) {
    var lis = q.querySelectorAll('.qc17__list li');
    if (!still && 'IntersectionObserver' in window) {
      onView(q.querySelector('.qc17__card'), function () { q.classList.add('is-run');
        [].forEach.call(lis, function (li, i) { setTimeout(function () { li.classList.add('on'); }, 250 + i * 170); }); }, 0.45);
    } else { [].forEach.call(lis, function (li) { li.classList.add('on'); }); }
    var fb = q.querySelector('.qc17__film');
    if (fb) fb.addEventListener('click', function () { open(innerWidth < 750 ? fb.getAttribute('data-narrow') : fb.getAttribute('data-video'), true); });
  }
})();

/* Jump bar "Assembly" (Tris 10 Oct): it points at the Delivery / Assembly / Dimensions tabs, so open the Assembly tab
   on the way there, whatever order the tabs are in. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[data-op-anchor][href="#op-dims"]');
  if (!a || !/assembl/i.test(a.textContent)) return;
  var sec = document.getElementById('op-dims');
  var t = sec && [].slice.call(sec.querySelectorAll('[data-op-tab]')).filter(function (b) { return /^\s*assembl/i.test(b.textContent); })[0];
  if (t && t.getAttribute('aria-selected') !== 'true') t.click();
});
